<template>
  <div>
    <div class="wrap coaching-finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>코치’s Comment</h3>
      </div>
      <div class="body-wrap">
        <incCourse :idx="idx"></incCourse>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>본 세션 코칭 주제</h3>
              <p class="preline">{{ comment.coarchingnoteSession }}</p>
            </li>
            <li>
              <h3>과제 및 차후 계획</h3>
              <p class="preline">{{ comment.coarchingnoteContent2 }}</p>
            </li>
            <li>
              <h3>코치’s Comment</h3>
              <p class="preline">{{ comment.coarchingnoteComment }}</p>
            </li>
            <!-- <li>
                            <h3>목표달성 날짜</h3>
                            <p class="preline">2021.12.21</p>
                        </li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incCourse from "@/components/inc/inc_course.vue";
export default {
  name: "coach_comment",
  props: {
    idx: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    comment: {},
    course: {},
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
  }),
  components: {
    incBack,
    incCourse,
  },
  mounted() {
    this.getCoachCommet();
  },
  methods: {
    getCoachCommet() {
      let params = {
        sessionIdx: this.idx,
      };
      this.axios
        .get("/front/coarching/complete/comment", { params })
        .then((res) => {
          if (res.data.success) {
            this.comment = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
